import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "invoices" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "Invoices", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Pay")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Print")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DollarOutlined = _resolveComponent("DollarOutlined")
  const _component_a_button = _resolveComponent("a-button")
  const _component_PrinterOutlined = _resolveComponent("PrinterOutlined")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_card = _resolveComponent("a-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode("div", null, [
          _createVNode(_component_a_table, {
            columns: _ctx.columns,
            rowKey: record => record.id,
            pagination: _ctx.pagination,
            "data-source": _ctx.invoices,
            loading: _ctx.isLoading,
            onChange: _ctx.handleTableChange
          }, {
            database: _withCtx(({ text: database }) => [
              database
                ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(database.name), 1))
                : _createCommentVNode("", true),
              (!database)
                ? (_openBlock(), _createBlock("span", _hoisted_4, "Credit"))
                : _createCommentVNode("", true)
            ]),
            total: _withCtx(({ text, record }) => [
              _createTextVNode(_toDisplayString(_ctx.convertMoney(text - record.refund)), 1 /* TEXT */)
            ]),
            action: _withCtx(({ text, record }) => [
              (record.status !== 'paid' && record.status !== 'refunded')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    class: "button-invoice",
                    type: "primary",
                    onClick: $event => (_ctx.$router.push(`/checkout/${record.id}`))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_DollarOutlined)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (record.status === 'paid' || record.status === 'refunded')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    class: "button-invoice",
                    onClick: $event => (_ctx.$router.push(`/invoice/${record.id}`))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_PrinterOutlined)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "rowKey", "pagination", "data-source", "loading", "onChange"])
        ])
      ]),
      _: 1
    })
  ]))
}